
<script>
import Layout from '@/router/layouts/main';
import OrderInfo from './main.vue';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Order',
  },
  components: {
    Layout,
    OrderInfo,
  },
  data() {
    return {
      items: [
        {
          text: '',
          href: '/orders/manage',
        },
        {
          text: '',
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout :title="$t('general.manage')">
    <OrderInfo :orderIdPublic="this.$route.params.idPublic" />
  </Layout>
</template>

